import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, HostListener, ChangeDetectorRef, ContentChild, TemplateRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { Table } from 'primeng/table';
import { IControlChangeEventArgs } from '@common/formbuilder/IControlChangeEventArgs';
import { IColumnOptions, IDataEndPoint } from '@framework/interfaces/IEntity';
import { ApiService } from '@services/api/api.service';
import { IPropertyFilter } from '../../../common/formbuilder/PropertyFilter';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import { DataStateChangeEvent, GridDataResult, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { GroupDescriptor, DataResult, process, State, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ViewType, FieldType } from '@framework/core/Enums';
import { ToastrService } from 'ngx-toastr';
import { ILookupSelectItem } from '../../../common/formbuilder/FormBuilderControl';
import { ToolbarActionsService } from '../../../services/toolbar-actions/toolbar-actions.service';
import { appSettings } from '@shared/components/appSettings';
@Component({
  selector: 'app-mf-table-v2',
  templateUrl: './mf-table-v2.component.html',
  styleUrls: ['./mf-table-v2.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush, //manaul change detection, huge speed improvement
  styles: [`
       .k-grid tr.selected { background-color: red; }
   `],
  encapsulation: ViewEncapsulation.None
})
export class MfTableV2Component implements OnInit {
  public self = this;
  private _data: any;
  public renderRows: boolean = false;
  public shouldRenderRows() {
    return (!this.parent || !this.parent?.parent || (this.toolbarActionsService?.selectedFormId == this.parent?.parent?.formIndex && this.toolbarActionsService?.selectedNestedFormId == this.parent?.listIndex) || this.parent?.dialogRef)
  }
  public includeDetailRows: boolean;
  private _filterCount: number;
  public rendering: boolean = false;
  public gridView: any = { data: [], total: 0 };
  public expandedDetailKeys = new Array();
  public filterOnInput: boolean = true;
  @Input() public disableSelect: boolean;
  @Input() public tableClass: string;
  @Input() public disableNavigation: boolean = false;
  @Input() public height: string = "100%";
  @Input() public groupingSubtotalCalcFunc: any;
  public rowHeight = 28.8;
  @Input() public lazyLoad: boolean = false;
  @Input() public parent: any;
  @Input() public loading: boolean = false;
  public searching: boolean = false;
  @Input() public globalSearchEnabled: boolean;
  @Input() public selectionByCheckbox: boolean;
  @Input() public set data(value) {
    this._data = value;
    this.expandedDetailKeys = new Array();
    if (this.lazyLoad == false) {
      this.rowHeight = null;
      if (value) {
        
        if (value.data) this.state.take = this.virtualClientSidePagingCount ? this.virtualClientSidePagingCount : value.data.length;
        else this.state.take = this.virtualClientSidePagingCount ? this.virtualClientSidePagingCount : value.length;
      }

    }
    else
      this.rowHeight = 28.8;
    if (this.grouped) {
      if (value) {
        value.forEach(o => {
          if (!o[this.groups[0].field]) {
            o[this.groups[0].field] = 'Empty';
          }
        })
        //if (this.grouping)

        this.state.group = this.groups;
        this.gridView = process(value, this.state);
      }
    }
    else {
      if (this.lazyLoad == false) {
        this.filterClientSide(this.state, true);
      }
      else this.gridView.data = value;
    }
    if (this.parent && this.parent.autoExpandDetailRows) {
      this.expandAll();
    }
    //if (this.state.skip == 0 && this.gridView.data.length > 0)
    //this.grid.autoFitColumns();
    //if (this.parent && this.parent.list && this.parent.list.autoFitColumns && this.grid)
    //  this.grid.autoFitColumns();
  }
  public get rawData() {
    return this._data;
  }
  @Input() public set filterCount(value) {
    this._filterCount = value;
    this.gridView.total = value;
    if (!this.lazyLoad && this.state)
      this.state.take = value;
  };
  public defaultFilters: CompositeFilterDescriptor = { filters: new Array<FilterDescriptor>(), logic: 'and' };
  public get filterCount() {
    return this._filterCount;
  };
  public groupingSubtotal: any;
  @ViewChild('detailRowTemplate', { read: ViewContainerRef }) detailComponentTarget: ViewContainerRef;
  @ViewChild('rowTemplate', { read: ViewContainerRef }) rowComponentTarget: ViewContainerRef;

  @Input() customDetailRowTemplate: TemplateRef<any>;
  @Input() customRowTemplate: TemplateRef<any>;
  public groups: GroupDescriptor[] = [{ field: 'id' }];
  public searchPhrase: any;
  public searchDebounce: any;
  @Input() public groupingSubtotalCalcField: any;
  @Input() public metadataTemplateItems: any;
  @Input() public skip: any = 0;
  @Input() public filter: any = {};
  @Input() public sort: any = {};
  @Input() public lazy: any = true;
  @Input() public scrollable: any = true;
  @Input() public virtualScroll: any = 'virtual';
  @Input() public columnsChangeRequireApiCall: boolean = true;
  @Input() public limitNumCharsEnabled: boolean = true;
  @Input() public limitNumChars: number = 60;
  @Input() public canDelete: boolean = false;
  @Input() public showFilterCol: boolean = true;
  @Input() public staticFilters: Array<IPropertyFilter>;
  @Input() public grouped: boolean = false;
  @Input() public rowGroupMetadata: any;
  public rowClassCallback = (context: RowClassArgs) => {
    if (this.parent?.list?.rowClassCallback) {
      return this.parent?.list?.rowClassCallback(context);
    }
    return '';
  };
  public get onCellClickActions() {
    return this.parent && this.parent.list.onCellClickActions ? this.parent.list.onCellClickActions : null
  }
  public get selectedItemActions() {
    return this.parent && this.parent.list.selectedItemActions ? this.parent.list.selectedItemActions : null
  }

  private _selectByIdentifier = 'id';
  public get virtualClientSidePagingCount() {
    return this.parent && this.parent.list.virtualClientSidePagingCount ? this.parent.list.virtualClientSidePagingCount : 0;
  }
  public get rows() {
    if (this.parent?.list?.rowCount)
      return this.parent?.list?.rowCount
    return (this.parent && this.parent.list.pageSize ? this.parent.list.pageSize : 50);
  }
  public get selectByIdentifier() {
    return this.parent && this.parent.list.rowIdentifier ? this.parent.list.rowIdentifier : this._selectByIdentifier;
  }
  private _groupingField: string = 'id';
  @Input() public set groupingField(value) {
    this._groupingField = value;
    this.groups = [{ field: value }];
    //this.state.group = this.groups

    //this.gridView = process(this._data, this.state);
  }; public get groupingField() {
    return this._groupingField;
  };
  @Input() public expandedRowKeys: any = {};
  @Input() public autoSizeColumns: boolean = true;
  @Input() public rowGroupMetadataActions: any;
  @Input() public grandTotal: any;
  private _parentInstance: any;
  @Input() public set parentInstance(val) {
    this._parentInstance = val;

  }
  public get parentInstance() {
    return this._parentInstance;
  }

  public Test: any;
 
  @Input() public formReadOnly: boolean;
  public _selectedIds: any[] = new Array();
  public set selectedIds(value) {

    this._selectedIds = value;
    if (value && value.length > 0 && this.gridView.data) {
      if (value.length == 1) {
        var filteredItems = this.gridView.data.filter(o => o[this.selectByIdentifier] == value[0]);
        this.selectedItem = filteredItems[0];
      }
      this.selectedItems = this.selectedItems.filter(o => value.indexOf(o[this.selectByIdentifier]) != -1);
      var filteredItems = this.gridView.data.filter(o => value.indexOf(o[this.selectByIdentifier]) != -1);
      filteredItems.filter(q => this.selectedItems.filter(i => i[this.selectByIdentifier] == q[this.selectByIdentifier]).length == 0).forEach(o => {
        if (this.selectedItems.filter(q => value.indexOf(q[this.selectByIdentifier]) == -1))
          this.selectedItems.push(o)
      })
    }
  }
  public selectedItems: any = [];
  public get selectedIds() {
    return this._selectedIds;
  }

  @Input() public set selectedColumns(value) {
    this._selectedColumns = value;
    if (!value) return;
    this.reloadTable();
    if (this.selectedColumns)
      this.selectedColumns.forEach(o => {
        if (o.formBuilderControl.controlType.viewType == ViewType.YesNo) {
          o.formBuilderControl.controlType.viewType = ViewType.CheckBox;
        }
      })
    this.selectedVisibleColumns = this.selectedColumns.filter(o => typeof (o.visible) == 'undefined'
      || (typeof o.visible == 'function' && o.visible(null, this.authService))
      || (typeof o.visible != 'function' && o.visible));
  }
  @Input() public set selectedmetadataTemplateItems(value) {
    this._selectedmetadataTemplateItems = value;
    if (!value) return;
    this.selectedmetadataTemplateItemsChange.emit(value);
  }
  @Input() public set selectedItem(value) {
    this._selectedItem = value;
    if (!value || !value.id || typeof value.id == 'undefined') return;
    // debugger;
    // if (value == null)
    //  this.selectedIds = [];
    this._selectedIds = [value.id];
  }
  @Output() public onItemClick: EventEmitter<any> = new EventEmitter();
  @Output() public onLoadItems: EventEmitter<any> = new EventEmitter();
  @Output() public selectedmetadataTemplateItemsChange = new EventEmitter();
  @Output() public selectedItemChange = new EventEmitter();
  @Output() public staticFiltersChange = new EventEmitter();
  @Output() public onDeleteItem = new EventEmitter();
  @Output() public onPageEvent = new EventEmitter();
  @Output() public onSortEvent = new EventEmitter();
  public onSelectedKeysChange(evt) {
    debugger;
    this.selectedIds = evt;
    //if (evt && evt.length > 0 && this.gridView.data) {
    //  var filteredItems = new Array();
    //  if (this.grouped) {
    //    var items = this.gridView.data.map(o => {
    //      return o.items
    //    }).reduce(function (a, b) { return a.concat(b); })
    //    filteredItems = items.filter(o => o.id == evt[0]);
    //  }
    //  else filteredItems = this.gridView.data.filter(o => o.id == evt[0]);
    //  this.selectedItem = filteredItems[0];
    // // this.mySelection = [];
    //}
  }
  public state: State = {
    skip: 0,
    take: this.rows,
    filter: this.defaultFilters,
    // group:this.groups
  };




  @ViewChild('dt', { static: true }) dt: Table;
  @ViewChild('test', { static: true }) testDiv: ElementRef<any>;;
  @ViewChild(GridComponent, { static: true })
  public grid: GridComponent;
  public selectedVisibleColumns: any;
  private _selectedmetadataTemplateItems: any[];
  private _selectedItem: any = {};
  private _columns: any[] = [];
  private _selectedColumns: any[];
  public currentFilterObject: any;
  public showFilters: boolean = true;
  public forceScrollable: boolean;
  public staticColumns: any[];
  public columns: ILookupSelectItem[];
  public filters: any = {};
  public viewType = ViewType;
  public detailRowHeight: any = 300;

  public advancedFilters: any[] = [];
  public constructor(public apiService: ApiService, public messageService: ToastrService, public authService: IdentityAuthService,
    public cdr?: ChangeDetectorRef, private componentFactoryResolver?: ComponentFactoryResolver,
    public toolbarActionsService?: ToolbarActionsService) {
    var self = this;
    self.toolbarActionsService.selectedNestedFormIdChange.subscribe(o => {
      var shouldRender = self.shouldRenderRows();
      if (shouldRender) {
        if (!self.renderRows) {
          self.rendering = true;
          self.selectedIds = [];
          setTimeout(() => {
            self.renderRows = shouldRender;
            // setTimeout(() => {
            self.rendering = false;
            // }, 1);
          }, 1)
        }
      }
      else self.renderRows = shouldRender;
    });
    self.toolbarActionsService.selectedFormIdChange.subscribe(o => {
      var shouldRender = self.shouldRenderRows();
      if (shouldRender) {
        if (!self.renderRows) {
          self.rendering = true;
          self.selectedIds = [];
          setTimeout(() => {
            self.renderRows = shouldRender;
            // setTimeout(() => {
            self.rendering = false;
            // }, 1);
          }, 1)
        }
      }
      else self.renderRows = shouldRender;

    })
  }

  public ngOnInit() {
    var _th = this;
    _th.renderRows = _th.shouldRenderRows();
    //if (this._parentInstance.afterInitObserver)
    //  this._parentInstance.afterInitObserver.subscribe(o => {
    //    debugger;
    //    setTimeout(_ => {
    //      this.height = this._parentInstance.testDivHeight;
    //    }, 1); 
    //  })
    //setTimeout(_ => {
    //  this.height = this.testDiv.nativeElement.clientHeight;
    //  if (!this.height) this.height = "100%";
    //  this.cdr.detectChanges();
    //}, 1);
    this.loadItems(this.state)



  }

  public ngAfterViewInit() {
    if (this.parent.list && this.parent.list.detailRowHeight) {
      this.detailRowHeight = this.parent.list.detailRowHeight;
    }
    if (this.parent.list && this.parent.list.masterDetailComponent) {
      var nestedComponent = this.componentFactoryResolver.resolveComponentFactory(this.parent.list.masterDetailComponent)
      this.detailComponentTarget.clear();
      let nestedComponentRef: any = this.detailComponentTarget.createComponent(nestedComponent);
      nestedComponentRef.instance.parent = this;
      var _th = this;
      setTimeout(function () {
        _th.customDetailRowTemplate = nestedComponentRef.instance.template;
        _th.cdr.detectChanges();
      }, 1)
      this.includeDetailRows = true;
    }

    if (this.parent.list && this.parent.list.rowDetailComponent) {
      var nestedComponent = this.componentFactoryResolver.resolveComponentFactory(this.parent.list.rowDetailComponent)
      this.rowComponentTarget.clear();
      let nestedComponentRef: any = this.rowComponentTarget.createComponent(nestedComponent);
      nestedComponentRef.instance.parent = this;
      var _th = this;
      setTimeout(function () {
        _th.customRowTemplate = nestedComponentRef.instance.template;
        _th.cdr.detectChanges();
      }, 1)
    }

    if (this.parent.list && this.parent.list.forceScrollable)
      this.forceScrollable = true;

  }

  //@HostListener('window:resize', ['$event.target'])
  //onResize() {
  //  setTimeout(_ => {
  //    this.height = this.parentInstance.testDivHeight;
  //    if (!this.height) this.height = "100%";
  //    this.cdr.detectChanges();
  //  });
  //}
  public onGlobalFilter(inputValue: string, force?: boolean): void {
    if (!this.filterOnInput && !force)
      return;
    var changed = this.searchPhrase != inputValue;
    this.searchPhrase = inputValue;
    var _th = this;
    if (changed) {
      if (_th.searchDebounce != null)
        clearTimeout(_th.searchDebounce);
      this.loading = true;
      _th.searchDebounce = setTimeout(function () {
        _th.globalSearch();
        //console.log('search' + _th.data);
      }, 500)
    }


  }

  public globalSearch() {
    var filters = new Array();
    this.selectedVisibleColumns.forEach(o => {
      filters.push({
        field: o.dbField,
        operator: 'contains',
        value: this.searchPhrase
      })
    })
    this.state.filter = {
      logic: 'or',
      filters: filters
    }
    this.state.skip = 0;
    this.state.take = this.rows;
    this.loadItems(this.state);
    this.loading = false;
  }

  public onCellClick(e) {
    if (this.parent.list && this.parent.list.expandDetailOnRowClick) {
      return
    }

    if (!e.column.field)
      return;
    this.onItemClick.emit(e.dataItem);
    if (this.disableNavigation)
      return;
    if (e.dataItem && this.gridView.data) {
      var filteredItems = new Array();
      if (this.grouped) {
        var items = this.gridView.data.map(o => {
          return o.items
        }).reduce(function (a, b) { return a.concat(b); })
        filteredItems = items.filter(o => o[this.selectByIdentifier] == e.dataItem[this.selectByIdentifier]);
      }
      else filteredItems = this.gridView.data.filter(o => o[this.selectByIdentifier] == e.dataItem[this.selectByIdentifier]);
      this.selectedItem = filteredItems[0];
      if (this.onCellClickActions && this.onCellClickActions.length > 0) {
        var filt = this.onCellClickActions.filter(o => { return o.field == e.column.field });
        if (filt.length > 0) {
          filt[0].action(this, this.selectedItem);
          return;
        }
      }
      this.selectedItemChange.emit(this.selectedItem);

    }


    //this.clickedRowItem = e.dataItem;
  }
  //public resize() {
  //  setTimeout(_ => {
  //    this.height = this.testDiv.nativeElement.clientHeight;
  //    if (!this.height) this.height = "100%";
  //    //this.cdr.detectChanges();
  //  }, 1);
  //}

  getGroupTotal(items) {
    var val = 0;
    if (this.groupingSubtotalCalcFunc) {
      if (!items)
        return '';

      return this.groupingSubtotalCalcFunc(items);
    }

    if (!items || !this.groupingSubtotalCalcField)
      return '';
    else
      val = items.map(o => {
        return o[this.groupingSubtotalCalcField]
      }).reduce(function (prev, cur) {
        return prev + cur;
      }, 0);
    return appSettings.currentCurrency.symbol + val.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 5 });
  }

  @Output() public onControlDataChange = new EventEmitter<IControlChangeEventArgs>();
  public get selectedmetadataTemplateItems() {
    return this._selectedmetadataTemplateItems;
  }
  public get selectedColumns() {
    return this._selectedColumns;
  }

  public get selectedItem() {
    return this._selectedItem;
  }
  //public rowCallback(context: RowClassArgs) {
  //  debugger;
  //  if (this.selectedItem && this.selectedItem.id)
  //  return {
  //    selected: this.mySelection.indexOf(this.selectedItem.id) != -1
  //  };
  //}

  public reloadTable(force?: boolean) {

    // this.filters = {};
    this.state.skip = 0;
    this.state.take = this.rows;
    //this.state.filter = this.defaultFilters
    //this.state.group = this.groups
    //if (force)
    //this.currentFilterObject = {};
    this.loadItems(this.state, force)
    //if (this.dt) {
    //  var arr = new Array();

    //  this._currentFilterObject = null;
    //  //if (this.lazyLoad)
    //  this.dt.onLazyLoad.emit(this.dt.createLazyLoadMetadata());
    //}
  }

  public pageChange(event) {
    this.state.skip = event.skip;
    this.state.take = event.take;
    this.loadItems(this.state);
  }
  public loadItems(event, force?: boolean) {
    //debugger;
    this.state = event;
    if (!this.selectedColumns)
      return;

    if (this.lazyLoad == false && !force) {
      this.filterClientSide(this.state);

      return;
    }
    this.expandedDetailKeys = new Array();
    let filterArr = new Array();
    if (this.state.filter) {
      this.state.filter.filters.forEach(filt => {
        var key: any = filt;
        var col = null;
        var cols = this._selectedColumns.filter(o => o.field == key.field || o.dbField == key.field);
        if (cols.length > 0)
          col = cols[0];

        if (col == null) {
          col = {
            field: key.field
          }
        }

        var val = key.value;
        if (typeof val === 'object') {
          val = JSON.stringify(val)
        }


        let whereExpressionType: any = col.whereExpressionType ? col.whereExpressionType : 1;
        if ( col.whereExpressionType == null) {
          var filterDescriptor: any = filt;
          switch (filterDescriptor.operator) {
            case "eq":
              whereExpressionType = 2;
              break;
            case "gte":
              whereExpressionType = 3;
              break;
            case "lte":
              whereExpressionType = 4;
              break;
            case "gt":
              whereExpressionType = 6;
              break;
            case "lt":
              whereExpressionType = 7;
              break;
          }
        }

        if (val !== null && val !== '')
          filterArr.push({ columnName: col.filterField ? col.filterField : col.field, filterValue: val, whereFilterType: col.whereFilterType, whereExpressionType: whereExpressionType })
      })
      //for (let key in this.state.filter.filters) {
      //  var col;
      //  var cols = this._selectedColumns.filter(o => o.field == key);
      //  if (cols.length > 0)
      //    col = cols[0];
      //  var val = event.filters[key].value;
      //  if (typeof val === 'object') {
      //    val = JSON.stringify(val)
      //  }
      //  filterArr.push({ columnName: key, filterValue: val, whereFilterType: col.whereFilterType, whereExpressionType: col.whereExpressionType })
      //}
    }
    if (this.staticFilters)
      this.staticFilters.filter(function (o) {
        return o.filterValue != '' && o.filterValue != null
      })
        .forEach(o => {
          filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
        });
    let filterObject = {
      StartCount: this.state.skip,
      PageSize: this.state.take,
      Filters: filterArr,
      Sort: null,
      SelectedColumns: !this.selectedColumns ? null : this.selectedColumns.filter(o => !o.ignoreInLazy).map(({ field }) => field)
    };
    if (this.state.sort && this.state.sort.length > 0)
      filterObject.Sort = { key: this.state.sort[0].field, Type: this.state.sort[0].dir == "asc" ? -1 : 1 };
    if (this.currentFilterObject && this.currentFilterObject == JSON.stringify(filterObject) && !force) {
      return;
    }

    this.currentFilterObject = JSON.stringify(filterObject);
    this.onLoadItems.emit(filterObject);
  }

  //public onSelectedKeysChange(e) {
  //  const len = this.mySelection.length; 

  //  //if (len === 0) {
  //  //  this.selectAllState = 'unchecked';
  //  //} else if (len > 0 && len < this.items.length) {
  //  //  this.selectAllState = 'indeterminate';
  //  //} else {
  //  //  this.selectAllState = 'checked';
  //  //}
  //}

  private curLoadItemsState: any;
  private debounceSearch: any;
  public dataStateChange(state: DataStateChangeEvent): void {
    var self = this;
    if (self.parentInstance)
      self.parentInstance.loading = true;
    if (self.debounceSearch)
      clearTimeout(self.debounceSearch);
    self.debounceSearch = setTimeout(() => {
      if (JSON.stringify(state) != self.curLoadItemsState) {
        self.curLoadItemsState = JSON.stringify(state);
        self.loadItems(state);
      }
      else {
        self.parentInstance.loading = false;
      }
    }, 500)
  }

  public filterClientSide(state, force?) {
    this.state = state;
    if (this.grouped) {
      this.state.group = this.groups;
      state.group = this.groups
    }
    if (!force && this.currentFilterObject && this.currentFilterObject == JSON.stringify(state)) {
      return;
    }
    this.currentFilterObject = JSON.stringify(state);
    if (this._data) {

      this.searching = true;
      //state.group = this.groups;
      this.gridView = process(this._data, state);

      if (this._data.length > 0)
        this.parentInstance.loading = false;
      this.searching = false;
    }

    //console.log(this.gridView);
    //this.loading = false;
  }

  public limitNumberOfChars(val: string) {
    if (!this.limitNumCharsEnabled)
      return val;
    if (val && val.length > this.limitNumChars)
      return val.substring(0, this.limitNumChars) + "...";
    else return val;
  }

  public controlDataChange(value: IControlChangeEventArgs) {
    this.onControlDataChange.emit(value);
  }

  public toggleShowFilters(event) {
    this.showFilters = !this.showFilters;
    event.stopPropagation();
    if (!this.showFilters)
      this.dt.reset()
  }

  public selectAllChange(col: IColumnOptions, value: boolean, control) {
    event.stopPropagation();
    if (this.formReadOnly)
      return;
    control.loading = true;
    if (typeof value != "undefined") {
      if (col.selectAllEndPoints) {
        let endPoint: IDataEndPoint = (col.selectAllEndPoints.insert && value) ? col.selectAllEndPoints.insert : (col.selectAllEndPoints.delete && !value) ? col.selectAllEndPoints.delete : null;
        if (endPoint) {
          let self: MfTableV2Component = this;
          self.apiService.exec({
            endPoint: endPoint,
            context: self,
            success: function (data) {
              control.loading = false;
              self.messageService.success('Successfully saved', 'Action');
              self.reloadTable(true);
              var listScope = self.parentInstance;
              if (listScope) {
                if (listScope.parent && listScope.parent.onBladeSave)
                  listScope.parent.onBladeSave(listScope);
                if (listScope.parent && listScope.parent.updateLists)
                  listScope.parent.updateLists();
                if (listScope.entityOptions && listScope.entityOptions.onSaveComplete) listScope.entityOptions.onSaveComplete(listScope, data);
                if (listScope.entityOptions && listScope.entityOptions.grid && listScope.entityOptions.grid.onSaveComplete) listScope.entityOptions.grid.onSaveComplete(listScope, data);
              }
            },
            error: function (error) {
              self.loading = false;
              self.messageService.error('Could not save', 'Action');
            }
          })
        }
      }
    }
  }

  public delete(event, rec) {
    this.onDeleteItem.emit(rec);
  }

  public onPage() {
    this.onPageEvent.emit();
  }

  onSort() {

    this.onSortEvent.emit();
  }


  public filterDataChanged(col) {
    //, col.whereExpressionType
    this.dt.filter(this.filters[col.dbField], col.field, col.filterMatchMode)
  }

  public clearFilters() {
    this.filters = new Array();
    this.dt.reset()
  }

  public getGroupItems(group) {
    var arr = new Array();
    var curIndex = group.index;
    while (curIndex < (group.index + group.size)) {
      arr.push(this.data[curIndex++])
    }
    return arr;
  }

  public isActionHidden(action) {
    if (action.visible)
      return !action.visible(this)
    else return false;
  }

  public showDetailRow(dataItem: any, index: number): boolean {
    if (this.parent && this.parent.list && this.parent.list.showDetailOnRow)
      return this.parent.list.showDetailOnRow(dataItem);
    return dataItem.extraDetails && dataItem.extraDetails.length > 0;
    return true;
  }

  public selectAll(arr, selectedIds, selectColumnId) {
    arr.forEach(o => {
      var id = o[selectColumnId];
      if (selectedIds.indexOf(id) == -1)
        selectedIds.push(id);
    })
  }
  public unSelectAll(arr, selectedIds, selectColumnId) {
    selectedIds.splice(0, selectedIds.length);
  }

  public expandAll() {
    
    this.gridView.data.forEach(o => {
      if (this.grouped) {
        if (o.items) {
          o.items.forEach(q => {
            var id = q[this.selectByIdentifier];
            if (this.expandedDetailKeys.indexOf(id) == -1)
              this.expandedDetailKeys.push(id);
          })
        }
      }
      else {
        var id = o[this.selectByIdentifier];
        if (this.expandedDetailKeys.indexOf(id) == -1)
          this.expandedDetailKeys.push(id);
      }
    })
  }
  public collapseAll() {
    this.expandedDetailKeys.splice(0, this.expandedDetailKeys.length);
  }

}
